import { Button } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.mediaQueries.sm}) {
    width: 50%;
  }
`;

export const CustomButton = styled(Button)<{ $borderColor: string; $backgroundColor: string }>`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  font-size: 12px;
  min-width: 80px;
  max-width: 100px;
  height: 100%;
  padding: 12px 16px !important;
  gap: 0 !important;
  border-radius: 8px !important;
  cursor: pointer;
  border: 1px solid ${({ $borderColor }) => $borderColor} !important;
  color: ${({ $borderColor }) => $borderColor} !important;
  border-color: ${({ $borderColor }) => $borderColor} !important;
  background-color: ${({ $backgroundColor }) => $backgroundColor} !important;

  &:hover {
    color: ${({ $borderColor }) => $borderColor} !important;
    border-color: ${({ $borderColor }) => $borderColor} !important;
    border: 1px solid ${({ $borderColor }) => $borderColor} !important;
  }

  &.ant-btn:focus,
  &.ant-btn:active {
    color: ${({ $borderColor }) => $borderColor} !important;
    border-color: ${({ $borderColor }) => $borderColor} !important;
    border: 1px solid ${({ $borderColor }) => $borderColor} !important;
  }

  &.ant-btn:hover {
    color: ${({ $borderColor }) => $borderColor} !important;
    border-color: ${({ $borderColor }) => $borderColor} !important;
    border: 1px solid ${({ $borderColor }) => $borderColor} !important;
  }

  @media (min-width: ${({ theme }) => theme.mediaQueries.sm}) {
    min-width: 100px;
    font-size: 14px;
  }
`;
